import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = {
  key: 0,
  class: "filter-item"
}
const _hoisted_4 = { style: {"text-align":"right","margin-right":"20px","margin-bottom":"10px","font-weight":"800"} }

import Pagination from '@/components/Pagination.vue'
import { useRouter,useRoute } from 'vue-router'
import { getCurrentInstance, reactive, ref, onMounted } from 'vue'
import { BrandM } from '@/models/brand'
import { BrandCat } from '@/enums/brand'
import { dateFormat } from '@/utils/index'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SupplierData',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const route = useRoute()

    const today = new Date()
    const filters = reactive({
            start_time:      dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${1}`), 
            end_time:        dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`), 
            cat_id:          '',
            province_id:'',
            city_id:'',   
            brand_id:'',
            time_type:3,
            page:        1,      // 当前页码
            page_size:          10,     // 每页显示条数
    })
    const state =reactive({
        dialogVisible: false,   // 弹框
        props:{
            expandTrigger: 'hover',
            value:'id',
            label:'lable',
            checkStrictly: true,
            children:'options'
        },
        city:'',
        options:[],
        update_time:'',
        summary_amount:'',
    })
    const brandProps = {
        value: 'id',
        label: 'name'
    }
    const tableData = ref([])
    const total = ref(0)
    const disabledStartDate = (date) => { // 返回不可用日期
        return date.getTime() > Date.now()
    }
    const disabledEndDate = (date) => { // 返回不可用日期
        var start = new Date(filters.start_time).getTime()
        //@ts-ignore
        var end = date.getTime() 
        return date.getTime() > Date.now() || end < start
    }
    // 获取列表数据
    const getList = () => {
        proxy.$http.get('/admin/products/get_shangwu_order_data', filters).then(res => {
            const { code, data, msg,count } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            total.value = data.total
            state.update_time = data.update_time
            state.summary_amount = data.summary_amount
        })
    }
    //获取品牌列表
    const brandList = ref<BrandM[]>([])
    const onBrandChange = (val) => {
        filters.brand_id = val
        getAllCityList()
        //判断城市列表是否包含所选择的省份或者城市，如果包含则不进行操作，如果不包含则清空城市列表
       // 判断并清空不合法的省份或城市选择
        let validProvince = false;
        let validCity = false;

        // 遍历所有省份
        for (const province of state.options) {
            // 检查 province_id 是否在省份列表中
            if (province.id === filters.province_id) {
                validProvince = true;
            }

            // 遍历每个省的城市列表来判断 city_id 是否存在
            if (province.options.some(city => city.id === filters.city_id)) {
                validCity = true;
            }
        }

        // 如果没有找到合法的省份，则清空 province_id
        if (!validProvince) {
            filters.province_id = '';
        }

        // 如果没有找到合法的城市，则清空 city_id
        if (!validCity) {
            filters.city_id = '';
        }
        getList()
    }
    // 获取全部城市
    const getAllCityList = () =>{
        proxy.$http.get('/cake_api/getCityListByBrandId', { brand_id: filters.brand_id }).then((res:any) => {
            // const { code, data, msg } = res
            if (res.code != 200) { return proxy.$message({ type: 'error', message: res.msg }) }
            state.options = res.data
            
        })
    }
    // 获取品牌列表
    const getBrandList = () =>{
        const{ province_id,city_id,cat_id } = filters
        proxy.$http.get('/admin/shop_product/getBrandList', { province_id: province_id, city_id: city_id, cat_id: cat_id}).then((res:any) => {
            // const { code, data, msg } = res
            if (res.code != 200) { return proxy.$message({ type: 'error', message: res.msg }) }
            brandList.value = res.data                  
        })
    }
    const handleChange= (value) => { 
        let processedProvinces = new Set(); // 用于记录已处理的省份ID
        let provinceIds = new Set(); // 存储最终的省份ID
        let cityIds = new Set(); // 存储城市ID
        filters.province_id = value[0]
        filters.city_id = value[1]
        getBrandList()
        //判断品牌列表是否包含所选择的品牌，如果包含则不进行操作，如果不包含则清空品牌
        if (brandList.value.length > 0) {
            let isBrandExist = brandList.value.some((brand) => brand.id == filters.brand_id);
            if (!isBrandExist) {
                filters.brand_id = '';
            }
        }
        getList()
    }
    const handleClear = () => {
        filters.province_id = ''
        filters.city_id = ''
    }
    const handleCatChange = (value) => {
        filters.brand_id = ''
        getBrandList() 
        getList()
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    onMounted(() => {
        getList()
        getAllCityList()
        getBrandList()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"margin-bottom":"20px"} }, [
      _createTextVNode("供应商销售额数据统计"),
      _createElementVNode("span", { style: {"margin-left":"20px","font-size":"14px","color":"#999"} })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select, {
        modelValue: filters.cat_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.cat_id) = $event)),
        clearable: "",
        filterable: "",
        placeholder: "请选择类型",
        class: "filter-item",
        style: {"width":"150px"},
        onChange: handleCatChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "蛋糕",
            value: _unref(BrandCat)['蛋糕']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "零食",
            value: _unref(BrandCat)['零食']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "鲜花",
            value: _unref(BrandCat)['鲜花']
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_cascader, {
        class: "filter-item",
        placeholder: "请选择城市",
        ref: "cardRef",
        props: state.props,
        options: state.options,
        onChange: handleChange,
        onClear: handleClear,
        modelValue: state.city,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.city) = $event)),
        "collapse-tags-tooltip": "",
        clearable: "",
        filterable: ""
      }, null, 8, ["props", "options", "modelValue"]),
      _createVNode(_component_el_select_v2, {
        class: "filter-item",
        modelValue: filters.brand_id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.brand_id) = $event)),
        placeholder: "请选择品牌",
        filterable: "",
        clearable: "",
        style: {"width":"200px"},
        props: brandProps,
        options: brandList.value,
        onChange: onBrandChange
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_component_el_radio_group, {
        modelValue: filters.time_type,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.time_type) = $event)),
        style: {"margin-right":"10px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio, {
            value: 1,
            label: "今年"
          }),
          _createVNode(_component_el_radio, {
            value: 2,
            label: "去年"
          }),
          _createVNode(_component_el_radio, {
            value: 3,
            label: "自定义"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (filters.time_type == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: filters.start_time,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.start_time) = $event)),
              "disabled-date": disabledStartDate,
              "value-format": "YYYY-MM-DD",
              placeholder: "开始日期"
            }, null, 8, ["modelValue"]),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: filters.end_time,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.end_time) = $event)),
              "disabled-date": disabledEndDate,
              "value-format": "YYYY-MM-DD",
              placeholder: "结束日期"
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("查询")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, "汇总销售额：" + _toDisplayString(state.summary_amount), 1),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "供应商名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cat_id",
          label: "类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "discount",
          label: "折扣"
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoice_type",
          label: "发票类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "tax_Point",
          label: "税点"
        }),
        _createVNode(_component_el_table_column, {
          prop: "city",
          label: "地区"
        }),
        _createVNode(_component_el_table_column, {
          prop: "total_amount",
          label: "销售额"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})